import React from "react";
import Chapter from "@/components/landing/Chapter";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "@/components/landing/Reveal";

const faqs = [
  {
    q: "¿Dónde se celebra?",
    a: "En Sevilla. La ubicación concreta se comunicará a las inscritas.",
  },
  {
    q: "¿Qué ocurre después de comprar mi entrada?",
    a: "Recibirás la confirmación de tu inscripción y toda la información previa. Además, tu inscripción incluye acceso gratuito durante tres meses al Mastermind Lidera con Voz Propia.",
  },
  {
    q: "¿El Mastermind se renueva automáticamente?",
    a: "No. A partir del cuarto mes funcionará como membresía mensual, pero no habrá renovación automática. Se notificará previamente.",
  },
  {
    q: "¿Puedo asistir si ya he participado en otra edición?",
    a: "Sí. Esta edición Primer Aniversario incorpora nuevas experiencias, nuevos contenidos y una evolución del formato inicial.",
  },
  {
    q: "¿Cuál es la diferencia entre Pase General y Experiencia VIP?",
    a: "El Pase General incluye la jornada presencial, networking, desayuno, almuerzo y acceso al Mastermind. La Experiencia VIP suma acceso prioritario, welcome pack personalizado, sesiones exclusivas con ponentes y la fiesta Primer Aniversario con crucero nocturno y cena con cata de vinos.",
  },
  {
    q: "¿A quién va dirigido?",
    a: "A empresarias, CEOs, directivas, fundadoras, propietarias de negocio y profesionales con marca personal que desean fortalecer su liderazgo, su comunicación, su visibilidad y su capacidad de generar alianzas estratégicas.",
  },
];

const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="bg-[#F4EFE7]">
      <div className="max-w-5xl mx-auto px-6 md:px-10 py-24 md:py-32 lg:py-40">
        <div className="max-w-3xl">
          <Reveal>
            <Chapter number="11" label="Preguntas frecuentes" />
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#3F403A]">
              Todo lo que necesitas saber
              <span className="italic text-[#63846F]"> antes de reservar.</span>
            </h2>
          </Reveal>
        </div>

        <Reveal delay={140}>
          <Accordion
            type="single"
            collapsible
            className="mt-12 md:mt-16 border-t border-[#3F403A]/15"
            data-testid="faq-accordion"
          >
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[#3F403A]/15"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  className="py-6 md:py-8 text-left hover:no-underline group"
                  data-testid={`faq-trigger-${i}`}
                >
                  <span className="flex items-baseline gap-5">
                    <span className="overline text-[#63846F] shrink-0">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-serif text-xl md:text-2xl lg:text-3xl leading-snug text-[#3F403A] group-hover:text-[#63846F] transition-colors">
                      {f.q}
                    </span>
                  </span>
                </AccordionTrigger>
                <AccordionContent
                  className="pl-12 md:pl-14 pb-8 pr-4 md:pr-8 font-sans text-base md:text-lg leading-relaxed text-[#3F403A]/85"
                  data-testid={`faq-content-${i}`}
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
